import {LOAD_STREAM, STOP_STREAM, STREAM_NAME} from 'actions/Stream';

const initialState = {
    openStream: false,
    matchId: undefined,
    src: undefined
};

const streamReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case LOAD_STREAM:
            return {
                ...state,
                openStream: true,
                matchId: action.data.matchId,
                src: action.data.src
            };
        case STOP_STREAM:
            return {
                ...state,
                src: undefined,
                matchId: undefined,
                openStream: false
            };
        default:
            return state;
    }
};

export default streamReducer;


// WEBPACK FOOTER //
// ./js/sport-betting/reducers/streamReducer.js